module.exports = __webpack_public_path__ + "static/img/cover.3b6b67e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cover.png
// module id = jYke
// module chunks = 8